__turbopack_context__.v({
  "contentContainer": "WaitlistForm-module__4B2nbG__contentContainer",
  "emailField": "WaitlistForm-module__4B2nbG__emailField",
  "emailRow": "WaitlistForm-module__4B2nbG__emailRow",
  "errorText": "WaitlistForm-module__4B2nbG__errorText",
  "formContainer": "WaitlistForm-module__4B2nbG__formContainer",
  "formSubtitle": "WaitlistForm-module__4B2nbG__formSubtitle",
  "formTitle": "WaitlistForm-module__4B2nbG__formTitle",
  "formTitleLight": "WaitlistForm-module__4B2nbG__formTitleLight",
  "logo": "WaitlistForm-module__4B2nbG__logo",
  "mainTitle": "WaitlistForm-module__4B2nbG__mainTitle",
  "shareButton": "WaitlistForm-module__4B2nbG__shareButton",
  "submitButton": "WaitlistForm-module__4B2nbG__submitButton",
  "subtitle": "WaitlistForm-module__4B2nbG__subtitle",
  "textContainer": "WaitlistForm-module__4B2nbG__textContainer",
});
